import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Formik, Field } from "formik";
import { Form, Button } from "react-bootstrap";
import { isEmpty, find, get, valuesIn, parseInt, isUndefined } from "lodash";
import {
  useRouterParams,
  useRequest,
  useDeepEffect,
} from "../../../../abstracts";
import { faTimes, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FieldInput,
  FieldDropSide,
  SearchableList,
  FieldButtonGroup,
  FieldInputFormatted,
  UploadComponentCustodianImage,
  AddPlans,
  ManageRkaasLayout,
  LoaderWrapper,
  AddButton,
  CsplTable as Table,
  SliderPanel,
  FieldIncrement,
  FormControlIncrementTrade,
} from "../../../../components";
import {
  FORM_PLACEHOLDERS,
  FLOW_TYPES,
  getFormattedPhone,
  manageRkaasFormNames,
  getPathWithParam,
  getFormattedZip,
  MANAGE_RKAAS_ROUTES,
  yesNoOptions,
  formFields,
  getAdvancedPathWithParam,
  getNullTableItem,
} from "../../../../utils";
import AccountDetailsContainer from "./AccountDetailsContainer";
import { getCompaniesList, getPlanList } from "../../../../services";
import { faLowVision } from "@fortawesome/pro-solid-svg-icons";

const onFormSubmit = (values) => {};

export const bankAccountNumberMasking = (accNo = "") => {
  return `XXX-XX-${accNo.slice(-4)} `;
};

const columns = [
  {
    label: "Custodian Account Number",
    className: "",
    columnName: "custodianAccountNumber",
  },
  {
    label: "Bank Account Number",
    className: "",
    columnName: "bankAccountNumber",
  },
  {
    label: "Plan Name",
    className: "",
    columnName: "planName",
  },
  {
    label: "Plan Id",
    className: "",
    columnName: "planId",
  },
];

function TimeComponent({ fieldName, values, setFieldValue, label }) {
  const optionsForAmpm = [
    {
      label: "AM",
      value: 1,
    },
    {
      label: "PM",
      value: 2,
    },
  ];
  const fieldNameHours = `${fieldName}.hours`;
  const fieldNameMinutes = `${fieldName}.minutes`;
  const fieldNameAmpm = `${fieldName}.ampm`;
  return (
    <>
      <div>{label}</div>
      <div className="d-flex time-component-styling">
        <Field
          size="xs"
          isRequired
          name={fieldNameHours}
          label={"Hours"}
          value={get(values, fieldNameHours, 0)}
          onChange={(val) => setFieldValue(fieldNameHours, val)}
          component={FormControlIncrementTrade}
        />
        <div style={{ marginTop: "30px" }} className="mx-2">
          :
        </div>

        <Field
          size="xs"
          isRequired
          name={fieldNameMinutes}
          label={"Minutes"}
          value={get(values, fieldNameMinutes, 0)}
          onChange={(val) => setFieldValue(fieldNameMinutes, val)}
          component={FormControlIncrementTrade}
        />
        <div style={{ marginTop: "30px" }} className="mx-2">
          :
        </div>
        <Field
          size="sm"
          name={fieldNameAmpm}
          label=" "
          style={{ height: "20px", padding: "0px" }}
          isRequired
          options={optionsForAmpm}
          selectedValue={get(values, fieldNameAmpm)}
          value={get(values, fieldNameAmpm)}
          onChange={(value) => {
            setFieldValue(fieldNameAmpm, value);
          }}
          component={FieldButtonGroup}
        />
      </div>
    </>
  );
}

function AddCustodianContainer(props) {
  const [isModalOpen, setIsModelOpen] = useState(false);
  const [modelIndex, setModelIndex] = useState(null);
  const { flow } = useRouterParams();
  const { history } = props;
  const [planList, setPlanList] = useState([]);
  const [planLoading, setPlanLoading] = useState(false);
  useDeepEffect(() => {
    setPlanLoading(true);
    getPlanList(0)
      .then((response) => {
        setPlanList(response);
        setPlanLoading(false);
      })
      .catch((error) => {
        setPlanLoading(false);
      });
  }, []);

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      link: getPathWithParam({
        path: MANAGE_RKAAS_ROUTES.CUSTODIAN,
      }),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "",
      variant: "link",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      icon: faTimes,
      link: getPathWithParam({
        path: MANAGE_RKAAS_ROUTES.CUSTODIAN,
      }),
    },
    {
      label: "",
      variant: "link",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      icon: faPencilAlt,
      onClick: () => {
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_RKAAS_ROUTES.ADD_CUSTODIAN,
            pathParam: [FLOW_TYPES.SAVE],
          })
        );
      },
    },
    {
      label: "",
      variant: "link",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      icon: faTrashAlt,
      link: getPathWithParam({
        path: MANAGE_RKAAS_ROUTES.CUSTODIAN,
      }),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  const formName = manageRkaasFormNames.ADD_CUSTODIAN;
  const fields = formFields[formName];
  const layoutHeader = "Create Custodian";
  return (
    <>
      <Formik
        initialValues={
          {
            custodianAccountDetails: [],
            [fields.cutOffTime]: 3,
          }
          // flow !== FLOW_TYPES.ADD
          //     ? {
          //         ...initialValues,
          //         ...response,
          //         ...(response?.additionalAddress || {}),
          //     }
          //     : { ...initialValues }
        }
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;
          return (
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManageRkaasLayout
                layoutHeader={layoutHeader}
                buttons={buttons}
                pageFlow={flow}
              >
                <p className="mt-20 plan-sub-heading">Basic details</p>
                <Field
                  size="md"
                  isRequired
                  name={fields.custodianName}
                  label={"Custodian Name"}
                  type="text"
                  autoComplete="off"
                  value={values[fields.custodianName]}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldInput}
                />
                <Field
                  size="md"
                  isRequired
                  name={fields.custodianID}
                  label={"Custodian ID"}
                  type="text"
                  autoComplete="off"
                  value={values[fields.custodianID]}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldInput}
                />
                <Field
                  size="md"
                  isRequired
                  name={fields.custodianEmail}
                  label={"Email"}
                  type="email"
                  autoComplete="off"
                  value={values[fields.custodianEmail]}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldInput}
                />
                <Field
                  size="md"
                  isRequired
                  name={fields.custodianPhoneNumber}
                  label={"Phone Number"}
                  type="text"
                  autoComplete="off"
                  value={getFormattedPhone(values[fields.custodianPhoneNumber])}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldInputFormatted}
                  placeholder={FORM_PLACEHOLDERS.phone}
                  maxLength="12"
                />
                <TimeComponent
                  fieldName={fields.cutOffTime}
                  label={"Cut off time"}
                  {...formProps}
                />
                <TimeComponent
                  fieldName={fields.clearanceTime}
                  label={"Clearance time"}
                  {...formProps}
                />
                <UploadComponentCustodianImage
                  name={"fields.uploadCensusAndPayroll"}
                  setFieldValue={setFieldValue}
                  label="Logo"
                />

                <div className="d-flex justify-content-between bg-title">
                  <div>
                    <h4 className="ft-20">Custodian account number</h4>
                  </div>
                  <div>
                    <AddButton
                      menu="rkaas"
                      subMenu="custodian"
                      onAddClick={() => {
                        setIsModelOpen(true);
                        setModelIndex(
                          get(values, "custodianAccountDetails", []).length
                        );
                      }}
                      // disabled={isEdit && !isSave}
                    />
                  </div>
                </div>
                {isEmpty(get(values, "custodianAccountDetails", [])) ? (
                  <AddPlans
                    menu="rkaas"
                    subMenu="custodian"
                    content="No Custodian account number "
                    buttonLabel="Add Custodian account number"
                    className="h-auto"
                    // disabled={isEdit && !isSave}
                    onPrimaryClick={() => {
                      setIsModelOpen(true);
                      setModelIndex(
                        get(values, "custodianAccountDetails", []).length
                      );
                    }}
                  />
                ) : (
                  <>
                    <Table>
                      <Table.Thead>
                        <Table.Tr>
                          {columns.map((item, index) => {
                            return (
                              <Table.Th key={index} className={item.className}>
                                {item.label}
                              </Table.Th>
                            );
                          })}
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {values?.custodianAccountDetails.map((val, ind) => {
                          return (
                            <>
                              <Table.Tr key={ind}>
                                {columns.map((item, cellIndex) => {
                                  const getContent = () => {
                                    if (item.columnName === "planName") {
                                      return get(
                                        planList.find(
                                          (_) => _.rkPlanNumber === val.planId
                                        ),
                                        "name",
                                        null
                                      );
                                    }
                                    if (
                                      item.columnName === "bankAccountNumber"
                                    ) {
                                      return bankAccountNumberMasking(
                                        val["bankAccountNumber"]
                                      );
                                    }
                                    return get(val, item.columnName);
                                  };
                                  return (
                                    <Table.Td
                                      key={cellIndex}
                                      className={item.className}
                                    >
                                      {getNullTableItem(getContent())}
                                    </Table.Td>
                                  );
                                })}
                              </Table.Tr>
                            </>
                          );
                        })}
                      </Table.Tbody>
                    </Table>
                  </>
                )}
                <SliderPanel
                  isOpen={isModalOpen}
                  size="55"
                  showCancel={false}
                  onCancel={() => setIsModelOpen(false)}
                >
                  <AccountDetailsContainer
                    planList={planList}
                    planLoading={planLoading}
                    fields={fields}
                    setOuterFieldValue={setFieldValue}
                    outerValues={values}
                    setIsModelOpen={setIsModelOpen}
                    modelIndex={modelIndex}
                  />
                </SliderPanel>
              </ManageRkaasLayout>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default AddCustodianContainer;
